import { WSFilter } from "@wingspanhq/fe-component-library";
import { Role } from "@wingspanhq/wingspan-api-sdk";

export const STAKEHOLDER_ROLE_FILTER_ALL = "All";

export function buildStakeholderFiltersConfig(roles: Role[]): WSFilter[] {
  if (roles.length === 0) {
    return [];
  }

  return [
    {
      title: "Role",
      name: "roleId",
      type: "radio",
      options: [
        {
          name: STAKEHOLDER_ROLE_FILTER_ALL,
          label: "All",
          hidePill: true
        },
        ...roles.map(role => ({
          name: role.id as string,
          label: role.name || (role.id as string)
        }))
      ]
    }
  ];
}
